import { IUserInfo } from "@home-health-notify/domain";
import {
  Box,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  Typography,
} from "@mui/material";
import React from "react";
import { Link } from "react-router";
import DisplayAvatarImage from "../common/DisplayAvatarImage";
import { ROUTES } from "../routes";
import { AVATAR_SIZE } from "../utils/AvatarUtils";

interface UserDirectoryListItemProps {
  userInfo: IUserInfo;
  chatID: string;
  testId: string;
}

function UserDirectoryListItem({
  userInfo,
  chatID,
  testId,
}: UserDirectoryListItemProps) {
  return (
    <ListItem
      data-testid={`${testId}-user-directory`}
      key={userInfo.id}
      disablePadding
      divider
      sx={{ minHeight: "65px" }}
    >
      <ListItemButton
        component={Link}
        to={`../${ROUTES.DIRECTORY}/private/${userInfo.id}/message`}
        divider
        sx={{ padding: "12px", minHeight: "65px" }}
        selected={chatID === userInfo.id}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center"
          }}>
          <ListItemAvatar>
            <DisplayAvatarImage
              avatarSize={AVATAR_SIZE.LARGE}
              src={userInfo.image}
              alt={userInfo.name}
            />
          </ListItemAvatar>
          <Typography>{userInfo.title}</Typography>
        </Box>
      </ListItemButton>
    </ListItem>
  );
}

export default UserDirectoryListItem;
